import { getViewerHandles } from "../runtime/viewerHandles";

/**
 * Scene object used as the parent for mesh-local overlays (axes, etc.).
 * Prefer the per-geom outer transform layer because it represents the visible
 * mesh origin instance after mesh-origin compensation.
 */
export function getMeshSceneAnchorObject(meshUuid, bodyUuid = null) {
  if (!meshUuid) return null;
  try {
    const { scene } = getViewerHandles();
    if (scene) {
      let outerLayer = null;
      let fallback = null;
      const objectMatchesBody = (obj) => {
        if (!bodyUuid) return true;
        const ud = obj.userData || {};
        if (String(ud.bodyUuid || "") === String(bodyUuid)) return true;
        let descendantMatch = false;
        if (typeof obj.traverse === "function") {
          obj.traverse((child) => {
            if (descendantMatch) return;
            if (String(child?.userData?.bodyUuid || "") === String(bodyUuid)) {
              descendantMatch = true;
            }
          });
        }
        return descendantMatch;
      };
      scene.traverse((obj) => {
        if (outerLayer) return;
        const ud = obj.userData || {};
        if (String(ud.meshName || ud.meshUuid || "") !== String(meshUuid)) return;
        if (!objectMatchesBody(obj)) return;
        if (!fallback) fallback = obj;
        if (ud.transformLayer === "outer") outerLayer = obj;
      });
      if (outerLayer) return outerLayer;
      if (fallback) return fallback;
    }
    if (typeof window !== "undefined" && window.sceneObjectsRef?.current?.[meshUuid]) {
      return window.sceneObjectsRef.current[meshUuid];
    }
  } catch {
    // ignore
  }
  return null;
}
